import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, Evidence } from '@eas/common-web';
import { useDictionaryEvidence } from '@composite/evidence/dictionary-evidence';
import { useDictionaryHookedSources } from '@components/evidence/dictionary-evidence/dictionary-hooked-sources';
import { DictPhysicalStorage } from '@models';
import {
  EntityName,
  EvidenceApiUrl,
  ExportTags,
  HistoryEntityType,
} from '@enums';
import { Fields } from './dict-physical-storage-fields';
import { useValidationSchema } from './dict-physical-storage-schema';

export function DictPhysicalStorages() {
  const validationSchema = useValidationSchema();
  const intl = useIntl();
  const { columnName, columnActive, columnOrder } =
    DictionaryEvidence.useDictionaryColumns<DictPhysicalStorage>();

  const evidence = useDictionaryEvidence<DictPhysicalStorage>({
    version: 2,
    identifier: 'PHYSICAL_STORAGE',
    apiProps: {
      url: EvidenceApiUrl.DICT_PHYSICAL_STORAGE,
      hookedSources: useDictionaryHookedSources({
        entityType: HistoryEntityType.PHYSICAL_STORAGE,
      }),
    },
    tableProps: {
      columns: [columnName, columnActive, columnOrder],
      tableName: intl.formatMessage({
        id: 'ES__DICT_PHYSICAL_STORAGE__TABLE__TITLE',
        defaultMessage: 'Fyzické úložiště',
      }),
      reportTag: ExportTags.DICT_PHYSICAL_STORAGE,
      defaultSorts: [
        { field: 'name', datakey: 'name', order: 'ASC', type: 'FIELD' },
      ],
      showBulkActionButton: false,
      showNamedSettingsButton: false,
    },
    detailProps: {
      entityName: EntityName.PHYSICAL_STORAGE,
      validationSchema,
      GeneralFieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__DICT_PHYSICAL_STORAGE__DETAIL__TITLE',
          defaultMessage: 'Fyzické úložiště',
        }),
      },
    },
  });

  return <Evidence {...evidence} />;
}
